import { render, staticRenderFns } from "./LexonButtonComponent.vue?vue&type=template&id=45a1af82&scoped=true"
import script from "./LexonButtonComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LexonButtonComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LexonButtonComponent.vue?vue&type=style&index=0&id=45a1af82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1af82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a1af82')) {
      api.createRecord('45a1af82', component.options)
    } else {
      api.reload('45a1af82', component.options)
    }
    module.hot.accept("./LexonButtonComponent.vue?vue&type=template&id=45a1af82&scoped=true", function () {
      api.rerender('45a1af82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonButton/LexonButtonComponent.vue"
export default component.exports